import React, { useEffect } from 'react';
import { AppThemeProvider, useAppTheme } from './AppTheme';
import { MUIThemeProvider } from './MUITheme';
import { ThemeProvider as OptigritThemeProvider, useTheme as useOptigritTheme } from '@optigrit/optigrit-ui/theme';

function ThemeSyncer({ children }) {
  const { theme } = useAppTheme();
  const { setTheme } = useOptigritTheme();

  useEffect(() => {
    setTheme(theme);
  }, [theme, setTheme]);

  return children;
}

export default function ThemeProvider({ children }) {
  return (
    <AppThemeProvider>
      <OptigritThemeProvider storageKey="optigrit-ui-theme">
        <ThemeSyncer>
          <MUIThemeProvider>{children}</MUIThemeProvider>
        </ThemeSyncer>
      </OptigritThemeProvider>
    </AppThemeProvider>
  );
}
